/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 无数据包裹分页 的 **请求配置**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/noDataPackage/listNoDataPackage`
 */
const postListNoDataPackageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/noDataPackage/listNoDataPackage",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postListNoDataPackage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据包裹分页 的 **请求函数**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/noDataPackage/listNoDataPackage`
 */
export const postListNoDataPackage = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postListNoDataPackageRequestConfig, requestData),
    ...args
  );
};
postListNoDataPackage.requestConfig = postListNoDataPackageRequestConfig;
/**
 * 接口 无数据包裹日志分页 的 **请求配置**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/noDataPackage/pageNoDataPackageRecord`
 */
const postPageNoDataPackageRecordRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/noDataPackage/pageNoDataPackageRecord",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPageNoDataPackageRecord",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据包裹日志分页 的 **请求函数**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/noDataPackage/pageNoDataPackageRecord`
 */
export const postPageNoDataPackageRecord = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postPageNoDataPackageRecordRequestConfig, requestData),
    ...args
  );
};
postPageNoDataPackageRecord.requestConfig =
  postPageNoDataPackageRecordRequestConfig;
/**
 * 接口 后台 - 生成无数据包裹 的 **请求配置**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/noDataPackage/addNoDataPackage`
 */
const postAddNoDataPackageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/noDataPackage/addNoDataPackage",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddNoDataPackage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 后台 - 生成无数据包裹 的 **请求函数**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/noDataPackage/addNoDataPackage`
 */
export const postAddNoDataPackage = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postAddNoDataPackageRequestConfig, requestData),
    ...args
  );
};
postAddNoDataPackage.requestConfig = postAddNoDataPackageRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/noDataPackage.js